import { Chip } from '@common-components';

interface MarketRequestItemLabelProps {
  text: string;
}

export default function MarketRequestItemLabel({ text }: MarketRequestItemLabelProps) {
  return <Chip label={text} color="secondary" size="small" />;
}
